"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFilterItem = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var camelCase_1 = tslib_1.__importDefault(require("lodash/camelCase"));
var AttributeFilterItem = /** @class */ (function (_super) {
    tslib_1.__extends(AttributeFilterItem, _super);
    function AttributeFilterItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelect = function () {
            var item = _this.props.item;
            item.onSelect(item.source);
        };
        return _this;
    }
    AttributeFilterItem.prototype.render = function () {
        var item = this.props.item;
        if (!item || item.source.empty) {
            return this.renderLoadingItem();
        }
        var classes = classnames_1.default("gd-list-item", "s-attribute-filter-list-item", "s-attribute-filter-list-item-" + camelCase_1.default(item.source.title), {
            "s-attribute-filter-list-item-selected": item.selected,
        });
        return (react_1.default.createElement("div", { className: classes, onClick: this.handleSelect },
            react_1.default.createElement("input", { type: "checkbox", className: "gd-input-checkbox", readOnly: true, checked: item.selected }),
            react_1.default.createElement("span", null, item.source.title)));
    };
    AttributeFilterItem.prototype.renderLoadingItem = function () {
        return react_1.default.createElement("div", { className: "gd-list-item gd-list-item-not-loaded" });
    };
    return AttributeFilterItem;
}(react_1.default.PureComponent));
exports.AttributeFilterItem = AttributeFilterItem;
//# sourceMappingURL=AttributeFilterItem.js.map